import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root',
})
export class SandboxService {
  constructor(private apiService: ApiBaseService) {}

  async getSandboxSettings(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/GetSandboxSettings', payload, true, true);
  }

  async saveSandboxLink(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/SaveSandboxLink', payload, true, true);
  }

  async removeSandboxLink(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/RemoveSandboxLink', payload, true, true);
  }

  async saveSandboxStructureMode(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/SaveSandboxStructureMode', payload, true, true);
  }

  async getSandboxSiteFolders(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/GetSandboxSiteFolders', payload, true, true);
  }

  async getSandboxProjectFolders(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/GetSandboxProjectFolders', payload, true, true);
  }

  async writeSandboxSiteFolder(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/WriteSandboxSiteFolder', payload, true, true);
  }

  async writeSandboxProjectFolder(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/WriteSandboxProjectFolder', payload, true, true);
  }

  async deleteSandboxFolder(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/DeleteSandboxFolder', payload, true, true);
  }

  async getSandboxProjectDirectory(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/GetSandboxProjectDirectory', payload, true, true);
  }

  async getSiteSandboxStatus(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/GetSiteSandboxStatus', payload, true, true);
  }

  async getSandboxRootFolders(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/GetSandboxRootFolders', payload, true, true);
  }

  async linkSiteSandboxFolder(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/LinkSiteSandboxFolder', payload, true, true);
  }

  async unlinkSiteSandboxFolder(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/UnlinkSiteSandboxFolder', payload, true, true);
  }

  async getSiteSandboxDirectory(payload: any, showLoader: boolean = true): Promise<any> {
    return this.apiService.httpRequest('SandboxService/GetSiteSandboxDirectory', payload, true, showLoader);
  }

  async uploadSandboxFile(formData: FormData): Promise<any> {
    return this.apiService.httpRequestForm('SandboxService/UploadSandboxFile', formData, true, true);
  }

  async getSandboxFolderItems(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/GetSandboxFolderItems', payload, true, true);
  }

  async createSandboxFolder(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/CreateSandboxFolder', payload, true, true);
  }

  async deleteSandboxItem(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/DeleteSandboxItem', payload, true, true);
  }

  async renameSandboxItem(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/RenameSandboxItem', payload, true, true);
  }

  async moveSandboxItem(payload: any): Promise<any> {
    return this.apiService.httpRequest('SandboxService/MoveSandboxItem', payload, true, true);
  }
}
